export default __webpack_public_path__ + "static/media/nfts-banner.5f0d1f9b.jpeg";